export const RTABAK_URLS = {
  API: {
    GetProducts: `${process.env.REACT_APP_API_URL}/products`,
    GetProductById: `${process.env.REACT_APP_API_URL}/products/`,
    GetProductsSpreadsheet: `${process.env.REACT_APP_API_URL}/products/spreadsheet`,
    getAllVariationsByProductId: `${process.env.REACT_APP_API_URL}/variation/`,
    PostProduct: `${process.env.REACT_APP_API_URL}/products`,
    PostProductImage: `${process.env.REACT_APP_API_URL}/products/image`,
    GetManufacturingCost: `${process.env.REACT_APP_API_URL}/manufacturingcost`,
    PostVariations: `${process.env.REACT_APP_API_URL}/variations`,
    ProductsByTopic: `${process.env.REACT_APP_API_URL}/productsByTopic`,
    CART: `${process.env.REACT_APP_API_URL}/cart`,
    GetHighlightedSearches: `${process.env.REACT_APP_API_URL}/highlightedSearches`,
    PostHighlightedSearch: `${process.env.REACT_APP_API_URL}/highlightedSearches`,
    Carousels: `${process.env.REACT_APP_API_URL}/carouselproducts`,
    Hero: `${process.env.REACT_APP_API_URL}/hero`,
    GetCategorybyDepartment: `${process.env.REACT_APP_API_URL}/category`,
  },
};
